import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {AuthService} from '../../core/services';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css', '../login/login.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  email: FormControl;
  submitted = false;
  error: string;
  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService) {
    this.email = new FormControl('', [Validators.required, Validators.email]);
  }

  ngOnInit() {
  }

  submit() {
    if (this.email.invalid) {
      return;
    }
    this.spinner.show('auth');
    this.authService.askResetPassword(this.email.value).subscribe( res => {
      this.spinner.hide('auth');
      if (res.success) {
        this.submitted = true;
      } else {
        this.error = 'אופס! המייל שהזנת אינו נכון';
      }
    });
  }

}
